export const inspectTable = [
  {
    content: "유해한 작업의 도급금지, 도급승인,도급 승인 시 하도급 금지, 적격 수급인 선정 (법 제58조~제61조)",
    isChecked: "",
  },
  {
    content: "도급인의 안전조치 및 보건조치 등 (법 제63조)",
    isChecked: "",
  },
  {
    content: "도급에 따른 산업재해 예방조치 (법 제64조)\n" +
      "- 안전･보건에 관한 협의체\n" +
      "- 작업장 순회점검\n" +
      "- 교육을 위한 장소·자료 제공\n" +
      "- 제29조제3항에 따른 안전보건교육 실시 확인\n" +
      "- 경보의 운영과 통보\n" +
      "- 위생 시설 이용 협조 등",
    isChecked: "",
  },
  {
    content: "도급인의 안전 및 보건에 관한 정보 제공 등 (법 제65조)",
    isChecked: "",
  },
  {
    content: "도급인의 관계수급인에 대한 시정조치 (법 제66조)",
    isChecked: "",
  },
  {
    content: "공사기간 단축 및 공법변경 금지 (법 제69조)",
    isChecked: "",
  },
  {
    content: "공사기간 연장, 설계변경의 요청 (법 제70조, 제71조)",
    isChecked: "",
  },
  {
    content: "기계ㆍ기구 등에 대한 건설공사도급인의 안전조치 (법 제76조)",
    isChecked: "",
  },
];
